import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import ReportFilters from './ReportFilters';
import ReportToolbar from './ReportToolbar';
import ColumnDeselector from './ColumnDeselector';
import CouplesByPriceTable from './CouplesByPriceTable';


const useStyles = makeStyles(theme => ({
    paper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
    },
    table: {
        minWidth: 650,
    },
    tableHeader: {
        backgroundColor: theme.palette.primary.main,
        '& .MuiTableCell-head': {
            color: theme.palette.primary.contrastText,
        },
    }
}));

const CouplesListDialog = (props) => {
    const {
        couples,
        open,
        setOpen
    } = props;

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <Dialog open={open} onClose={handleClose} scroll='paper' maxWidth='lg'>
            <DialogTitle>
                Couples
                {couples.year ? ` for $${couples.price} in ${couples.year}` : ''}
                {couples.count > 0 && (<small><br />Count: {couples.count}</small>)}
            </DialogTitle>
            <DialogContent>
                {couples.count > 0 && <CouplesByPriceTable data={couples} />}
                {couples.loading && (
                    <div>
                        <CircularProgress />
                    </div>
                )}
                {!couples.loading && couples.count === 0 && <span>No data</span>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}

const BookingsByPricePoint = () => {
    const classes = useStyles();
    const reportUrl = '/api/reports/bookings-by-price-point';
    const reportTitle = 'Bookings By Price Point Report';
    const pageTitle = `${reportTitle} - Enduring Promises`;
    const [data, setData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [couples, setCouples] = React.useState({
        count: 0,
        weddingList: [],
        loading: false
    });

    const showDialog = (price, year) => {
        setCouples({ count: 0, weddingList: 0, loading: true });
        setDialogOpen(true);
        const statuses = state.multi_select_status.join(',');
        fetch(`/api/reports/bookings-by-price-point/couples?status=${statuses}&price=${price}&year=${year}`)
            .then(response => {
                return response.json();
            })
            .then(result => {
                setCouples({
                    count: result.count,
                    weddingList: result.weddingList,
                    year: result.year,
                    price: result.price,
                    loading: false
                })
            })
    }

    const sortColumns = (result) => {
        result.columns.sort((a,b) => {
            if (a == 485) {
                return -8;
            }
            if (a == 550) {
                return -7;
            }
            if (a == 595) {
                return -6;
            }
            if (a == 350) {
                return -5;
            }
            if (a == 295) {
                return -4;
            }
            if (a == 275) {
                return -3;
            }
            if (a == 315) {
                return -2;
            }
            if (a == 400) {
                return -1;
            }
            return 0;
        });
        return result;
    }

    const getData = () => {
        const statuses = state.multi_select_status.join(',');
        new Promise((resolve, reject) => {
            fetch(`${reportUrl}?status=${statuses}`)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    sortColumns(result);
                    setData(result);
                    resolve();
                })
                .finally(() => {
                    setLoading(false);
                });
        });
    };

    useEffect(() => {
        document.title = pageTitle;
        getData();
    }, [1]);

    const csvData = (data) => {
        const rows = [];
        Object.entries(data.data).forEach(row => {
            const rowData = [];
            data.columns.map((x,i) => {
                rowData.push(row[1].fees[x] || 0);
            });
            rows.push([row[0], ...rowData, row[1].num_weddings, row[1].rehearsals]);
        });
        return {
            filename: 'bookings-report.csv',
            columns: ['Year', ...data.columns, 'Weddings', 'Rehearsals'],
            rows,
        }
    }

    const [state, setState] = React.useState({
        multi_select_status: ['Booked', 'Complete'],
    });

    const handleSubmit = () => {
        getData(state);
    };

    let pastSelections = localStorage.getItem('enduringpromises.com.bookingsbyprice.selected');
    pastSelections = pastSelections ? pastSelections.split(',').map(x => parseInt(x)) : [];
    const [selected, setSelected] = useState(pastSelections)

    const filteredColumns = data !== null ? data.columns.filter(x => !selected.includes(x)) : []

    return (
        <Paper square className={classes.paper}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">{reportTitle}</Typography>
                </Grid>
                <Grid item xs={8}>
                    <ReportFilters
                        state={state}
                        setState={setState}
                        handleSubmit={handleSubmit}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                    >
                        {data !== null && (
                            <Box display='flex'>
                                <ReportToolbar data={csvData(data)} />
                                <ColumnDeselector options={data.columns} selected={selected} setSelected={setSelected} />
                            </Box>
                        )}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper} variant="outlined" square>
                        <Table className={classes.table} size="small">
                            {!loading && data !== null && (
                                <TableHead className={classes.tableHeader}>
                                    <TableRow>
                                        <TableCell align="left">Year</TableCell>
                                        {filteredColumns.map((column, k) => (
                                            <TableCell align="center" key={k}>{column}</TableCell>
                                        ))}
                                        <TableCell align="left">Weddings</TableCell>
                                        <TableCell align="left">Rehearsals</TableCell>
                                    </TableRow>
                                </TableHead>
                            )}
                            <TableBody>
                            {!loading && data !== null && Object.entries(data.data).map(([i, value]) => (
                                <TableRow key={`row-${i}`}>
                                    <TableCell align="left">{i}</TableCell>
                                    {Object.values(filteredColumns).map((column, k) => {
                                        const feeCount = value.fees[column] || 0;
                                        const renderFeeCell = (feeCount, year) => {
                                            if (feeCount) {
                                                return (<span><a href="#" onClick={() => showDialog(column, year)}>{feeCount}</a></span>)
                                            }
                                            return (<span>0</span>)
                                        }
                                        return (
                                            <TableCell key={k} align='center'>{renderFeeCell(feeCount,i)}</TableCell>
                                        )
                                    })}
                                    <TableCell align="left">{value.num_weddings}</TableCell>
                                    <TableCell align="left">{value.rehearsals}</TableCell>
                                </TableRow>
                            ))}
                            {!loading && data !== null && data.data.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={filteredColumns.length + 2} align="center">No data</TableCell>
                                </TableRow>
                            )}
                            {loading && (
                                <TableRow>
                                    <TableCell colSpan={14} align="center">
                                        <CircularProgress color="primary" />
                                    </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
            <CouplesListDialog couples={couples} open={dialogOpen} setOpen={setDialogOpen} />
        </Paper>
    );
}

export default BookingsByPricePoint;
